@if (selectedType) {
  <app-data-layer-type-form
    [cancelLevel]="1"
    *ngIf="selectedType.type === 'Polygon'"
    [allowInitialYears]="false"></app-data-layer-type-form>
  <app-poi-data-layer-type-form
    [cancelLevel]="1"
    *ngIf="selectedType.type === 'Point'"
    [allowInitialYears]="false"></app-poi-data-layer-type-form>

  <div *ngIf="typeLayers.length" class="-mx-3 -mb-3 mt-5 p-3 surface-ground">
    <app-header
      styleClass="mt-4 mb-4"
      icon="fas fa-calendar-days"
      [help]="selectedType.type === 'Polygon' ? '' : 'Standorte pro Jahr'"
      [text]="
        selectedType.type === 'Polygon'
          ? 'Jahre im Raum'
          : 'Jahre der Standorte'
      "></app-header>
    <p-tabMenu [model]="dataLayerMenuItems" />

    <div class="grid -mt-2" *ngIf="selectedLayer">
      <div class="col-12">
        <div class="p-card p-3">
          <app-data-layer-form [disableCancelLink]="true"></app-data-layer-form>
        </div>
      </div>
      <div class="col-12">
        <div class="p-card p-3">
          <app-feature-form
            [type]="selectedType.type"
            [selectedLayer]="selectedLayer"></app-feature-form>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!typeLayers.length">
    <app-alert header="Keine Jahre vorhanden" [canToggle]="false">
      <p>
        Fügen Sie ein Jahr hinzu, damit Sie Geodaten und Daten hinterlegen
        können.
      </p>
      <p-button
        [rounded]="true"
        label="Jahr hinzufügen"
        severity="success"
        icon="fas fa-circle-plus"
        (click)="addYear()"></p-button>
    </app-alert>
  </div>
} @else {
  <app-alert [canToggle]="false" header="404">
    Kein Zugriff / Nicht gefunden
  </app-alert>
}

@if (addDataLayerForm) {
  <p-sidebar
    (onHide)="closeDataLayerForm()"
    position="right"
    [modal]="false"
    [styleClass]="'w-7'"
    [visible]="addDataLayerForm">
    <ng-template pTemplate="header">
      <app-header
        icon="fas fa-calendar-days"
        text="Jahr hinzufügen"></app-header
    ></ng-template>
    <ng-container *ngIf="addDataLayerForm">
      <app-data-layer-form
        [cancelLevel]="0"
        (cancel)="closeDataLayerForm()"
        (formSubmitted)="closeDataLayerForm($event)"
        [forceNew]="true"
        [parent]="selectedType"></app-data-layer-form>
    </ng-container>
  </p-sidebar>
  <app-mask
    [visible]="addDataLayerForm"
    (click)="closeDataLayerForm()"></app-mask>
}
